import { TFunction } from "i18next";
import { OrganizationTableSortColumn } from "node-library/dist/paginations";


export function getOrganizationSortString(
    sortColumn: OrganizationTableSortColumn,
    translation: TFunction<"translation", undefined>
): string {
    switch (sortColumn) {
        case OrganizationTableSortColumn.CLIENT_COMPANY_NAME:
            return translation("CompanyName");
        case OrganizationTableSortColumn.INSERTED:
            return translation("CreateTime");
    }
}